'use strict';

/* global $ */
/* global window */
/* TODO: ES6 Button! */

(function () {
    var selector = '.js-favorite-button';

    var FavoriteButton = {};
    FavoriteButton.parse = function () {
        $(selector).each(function (index, button) {
            var $button = $(button);

            $button.on('click', function (event) {
                event.preventDefault();
                $button.addClass('disabled');

                var pill = $('.js-favorite-amount', $button);
                var likes = (pill.length) ? parseInt(pill.html()) : 0;
                var tmp = $button.data('alt-label');
                if(tmp) {
                    $button.data('alt-label', $button[0].childNodes[0].nodeValue);
                    $button[0].childNodes[0].nodeValue = tmp;
                }
                // ----- Remove from favorites
                if($button.hasClass('liked')) {
                    $button.removeClass('liked');
                    if(likes) {
                        if(likes === 1) pill.html('');
                        else pill.html(likes - 1);
                    }

                    mymuesli.api.remove('Accounts.Favorites', {
                        'id': $button.data('favorite-identifier')
                    }, {}, function() {
                        $button.removeClass('disabled');
                    });
                // ----- Add to favorites
                } else {
                    $button.addClass('liked');
                    if(likes) pill.html(likes + 1);
                    else pill.html(1);
                    App.Interface.Api.post('Accounts.Favorites', [], {
                        'product': $button.data('id')
                    }, {
                        key: mymuesli.getVariable('analytics.key'),
                        contentType: 'application/json',
                    }, function(response) {
                        $button.data('favorite-identifier', response.favoriteID);
                        $button.removeClass('disabled');
                    });
                }
            });
        });
    };

    $(FavoriteButton.parse);

}) ();

$(function () {
    var favorites = $.cookie('mmUserFavorites');
    if (!favorites) {
        return;
    }
    favorites = JSON.parse(favorites);
    $('.js-favorite-button').each(function (_, favoriteButton) {
        var $favoriteButton = $(favoriteButton);
        if ($favoriteButton.hasClass('.js-is-favorite') && favorites[$favoriteButton.data('product-id')]) {
            $favoriteButton.removeClass('hidden');
        } else if ($favoriteButton.hasClass('.js-no-favorite') && !favorites[$favoriteButton.data('product-id')]) {
            $favoriteButton.removeClass('hidden');
        }
    });
});
